import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiService } from "../../Component/services/apiServices";
import AccountHeader from "../../Component/Header/account_header";
import Alert from 'react-bootstrap/Alert';
import Footer from "../../Component/Footer";
function Pages() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const didMountRef = useRef(true)
  const [pageData, setPageData] = useState({});
  const [pageContent, setPageContent] = useState("");
  const [contactInputs, setcontactInputs] = useState({
    contact_name: "",
    contact_email: "",
    contact_mobile: "",
    contact_event_date: "",
    contact_call_time: "",
    contact_type: 1,
    contact_subject: "",
    contact_message: "",
  });
  const [errorMessage, seterrorMessage] = useState(false)
  const [successMessage, setsuccessMessage] = useState(false)
  const [buttonLoader, setButtonLoader] = useState(false)
  useEffect(() => {
    if (didMountRef.current) {
      const getpagesData = {
        slug: slug,
      };
      ApiService.postData('pages-data', getpagesData).then(res => {
        if (res.status === 'success') {
          setPageData(res?.data)
          setPageContent(res?.data?.page_content);
        } else if (res.status === 'error' && res.message === "Page Not Found") {
          navigate('/error_404')
        }
      })
    }
    didMountRef.current = false;
  }, [slug, navigate])

  const handleContactInput = (e) => {
    seterrorMessage('')
    const { name, value } = e.target;
    setcontactInputs({
      ...contactInputs,
      [name]: value,
    });
  };

  const ContactformHandle = () => {
    let counter = 0;
    const myElements = document.getElementsByClassName("required");
    for (let i = 0; i < myElements.length; i++) {
      if (myElements[i].value === '') {
        myElements[i].style.border = '1px solid red';
        counter++;
      } else {
        myElements[i].style.border = '';
      }
    }
    if (counter === 0) {
      if (contactInputs?.contact_name === "") {
        seterrorMessage('Please Enter Your Name')
        return;
      }
      if (contactInputs?.contact_email === "") {
        seterrorMessage('Please Enter Your Email Address')
        return;
      }
      const validEmail = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
      if (!validEmail.test(contactInputs?.contact_email)) {
        seterrorMessage('Please Enter Valid Email Address');
        return;
      }
      if (contactInputs?.contact_mobile === "") {
        seterrorMessage('Please Enter Your Mobile Number');
        return;
      }
      setButtonLoader(true);
      ApiService.postData("contact-us-process", contactInputs).then(
        (res) => {
          if (res?.status === "success") {
            setsuccessMessage(res.message)
            setcontactInputs((prevState) => ({
              ...prevState,
              contact_name: "",
              contact_email: "",
              contact_mobile: "",
              contact_event_date: "",
              contact_call_time: "",
              contact_type: 1,
              contact_subject: "",
              contact_message: "",
            }));
            setButtonLoader(false);
            setTimeout(() => {
              setsuccessMessage("");
            }, 3000);
          } else if (res?.status === "error") {
            setButtonLoader(false);
            seterrorMessage(res.message);
            setTimeout(() => {
              seterrorMessage("");
            }, 3000);
          }
        }
      );
    }
  };

  return (
    <>
      <AccountHeader heading={pageData?.page_name}></AccountHeader>
      <div id='appCapsule'>
        <div >
          {pageContent != null ? (
            <div dangerouslySetInnerHTML={{ __html: pageContent }}></div>
          ) : (
            ""
          )}
        </div>
        {slug === 'catering' &&
          (
            <>
              <section className="section-gap-sm">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-7">
                      <div className="section-title">
                        <h2>Contact Us</h2>
                        <p>To Get More Information About Our Catering Services</p>
                      </div>
                      {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                      {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                      <div className="row g-3">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Full Name</label>
                            <input type="text" name="contact_name" className="form-control required" placeholder="Enter your full name" value={contactInputs.contact_name} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Email Address</label>
                            <input type="email" name="contact_email" className="form-control required" placeholder="Enter your email address" value={contactInputs.contact_email} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Mobile Number</label>
                            <input type="number" name="contact_mobile" className="form-control required" placeholder="Enter your mobile number" value={contactInputs.contact_mobile} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Event Date</label>
                            <input type="date" name="contact_event_date" className="form-control required" value={contactInputs.contact_event_date} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Preferred Call Time</label>
                            <input type="text" name="contact_call_time" className="form-control required" placeholder="Preferred time for call" value={contactInputs.contact_call_time} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Subject</label>
                            <input type="text" name="contact_subject" className="form-control required" placeholder="Enter subject" value={contactInputs.contact_subject} onChange={handleContactInput} />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Message</label>
                            <textarea name="contact_message" rows="5" className="form-control required" placeholder="Write your message here..." value={contactInputs.contact_message} onChange={handleContactInput}></textarea>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <button type="button" className="btn-md btn btn-primary mb-5" onClick={ContactformHandle} disabled={buttonLoader}>{buttonLoader ? <img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" /> : 'Submit'}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <Footer></Footer>
            </>
          )
        }
      </div>
    </>
  )
}

export default Pages